<!--
  WARNING!

  this file was automatically generated and should be updated using:

  ng g lazy-component components/checkout-receipt-requisition/checkout-receipt-requisition.component.ts
-->
<ng-template #anchor></ng-template>
